export const APPS_DB = {
  STORES: {
    SMART_FOLDERS: 'smart-folders',
    BLOCK_OVERRIDES: 'block-overrides',
    FILE_SMART_FOLDERS: 'file-smart-folders',
    PITCH_MASTER: 'pitch-master',
  },
  ENTRIES: {
    AGENDA: 'agenda',
    CONFIGURATION: 'configuration',
    BLOCK_OVERRIDES: 'block_overrides_by_block_id',
    FILE_SMART_FOLDERS: 'file_smart_folders_configuration',
  },
  GLOBAL_STORES: {},
  GLOBAL_ENTRIES: {},
} as const
